import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-percentage-textbox',
    templateUrl: './question-percentage-textbox.component.html',
    styleUrls: ['./question-percentage-textbox.component.scss'],
    standalone: false
})
export class QuestionPercentageTextboxComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() showLabelQuestionCopy = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-percentage-${newGuid()}`;
  uniqueId = `textbox-percentage-id-${newGuid()}`;
  value = '';

  constructor() { }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
  }

  saveValue(): void {
    if (this.value && this.question) {
      this.question.answer = this.value.toString();
      this.questionAnswer.emit(this.question);
    }
  }
}
